export var EIncludeTariffs;
(function (EIncludeTariffs) {
    EIncludeTariffs[EIncludeTariffs["Empty"] = 0] = "Empty";
    EIncludeTariffs[EIncludeTariffs["FreeTransport"] = 1] = "FreeTransport";
    EIncludeTariffs[EIncludeTariffs["FreeMessengers"] = 2] = "FreeMessengers";
    EIncludeTariffs[EIncludeTariffs["FreeSocials"] = 3] = "FreeSocials";
    EIncludeTariffs[EIncludeTariffs["FreeMusik"] = 4] = "FreeMusik";
    EIncludeTariffs[EIncludeTariffs["FreeVideo"] = 5] = "FreeVideo";
})(EIncludeTariffs || (EIncludeTariffs = {}));
